
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class EntityLinkDialog extends SiteEntityDialog<EntityLinkRow, any> {
        protected getFormKey() { return EntityLinkForm.formKey; }
        protected getIdProperty() { return EntityLinkRow.idProperty; }
        protected getLocalTextPrefix() { return EntityLinkRow.localTextPrefix; }
        protected getNameProperty() { return EntityLinkRow.nameProperty; }
        protected getService() { return EntityLinkService.baseUrl; }
        protected getDeletePermission() { return EntityLinkRow.deletePermission; }
        protected getInsertPermission() { return EntityLinkRow.insertPermission; }
        protected getUpdatePermission() { return EntityLinkRow.updatePermission; }

        protected form = new EntityLinkForm(this.idPrefix);

    }
}